import React from 'react'
import Loader from '../../assets/images/loader.svg'

const CircularProgress = (props) => <div className={'loader'} {...props}>
  <Loader />
</div>

export default CircularProgress
